function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from 'axios';
var __AQE_INTERNALS__ = {};
function validateInternals() {
  if (!Object.keys(__AQE_INTERNALS__).length) {
    throw new Error('[aqe] configuration has not been set');
  }
  if (!__AQE_INTERNALS__.appName) {
    throw new Error('[aqe] appName is required');
  }
}
var Aqe = /*#__PURE__*/function () {
  function Aqe() {
    _classCallCheck(this, Aqe);
  }
  return _createClass(Aqe, [{
    key: "set",
    value: function set(configOrKey, value) {
      if (value && typeof configOrKey === 'string') {
        __AQE_INTERNALS__[configOrKey] = value;
      } else {
        Object.assign(__AQE_INTERNALS__, configOrKey);
      }
      return this;
    }
  }, {
    key: "defaults",
    get: function get() {
      validateInternals();
      return _objectSpread({}, __AQE_INTERNALS__);
    }
  }, {
    key: "useAxiosInterceptor",
    value: function useAxiosInterceptor(type, onFulfilled, onRejected) {
      return axios.interceptors[type].use(onFulfilled, onRejected);
    }
  }, {
    key: "ejectAxiosInterceptor",
    value: function ejectAxiosInterceptor(type, id) {
      axios.interceptors[type].eject(id);
    }
  }]);
}();
var aqe = new Aqe();
export default aqe;